import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Import Types
import type { QueryConfigurations } from 'types';

export interface QueryConfigurationsSliceState {
    baseData: QueryConfigurations;
    exclusionRules: QueryConfigurations;
}

export const initialState: QueryConfigurationsSliceState = {
    baseData: {},
    exclusionRules: {},
};

export const queryConfigurationsSlice = createSlice({
    name: 'queryConfigurations',
    initialState,
    reducers: (create) => ({
        setBaseQueryConfigurations: create.reducer((state, { payload }: PayloadAction<QueryConfigurations>) => {
            state.baseData = { ...payload };
        }),
        clearBaseQueryConfigurations: create.reducer((state) => {
            state.baseData = {};
        }),
        setExclusionRulesQueryConfigurations: create.reducer(
            (state, { payload }: PayloadAction<QueryConfigurations>) => {
                state.exclusionRules = { ...payload };
            },
        ),
        clearExclusionRulesQueryConfigurations: create.reducer((state) => {
            state.exclusionRules = {};
        }),
    }),
    selectors: {
        selectBaseQueryConfigurations: (queryConfigurations) => queryConfigurations.baseData,
        selectExclusionRulesQueryConfigurationsState: (queryConfigurations) => queryConfigurations.exclusionRules,
    },
});

export const {
    setBaseQueryConfigurations,
    clearBaseQueryConfigurations,

    setExclusionRulesQueryConfigurations,
    clearExclusionRulesQueryConfigurations,
} = queryConfigurationsSlice.actions;

export const { selectBaseQueryConfigurations, selectExclusionRulesQueryConfigurationsState } =
    queryConfigurationsSlice.selectors;
